import React from "react";

export const CALIBRATION_CHECK_HELP_TITLE = "Check de calibragem";

export function CalibrationCheckHelpContent() {
  return (
    <>
      <p>
        <strong>Para que serve?</strong> Acompanhar a{" "}
        <strong>calibragem e a dosagem</strong> do equipamento ao longo da
        operação — verificando se a configuração inicial se mantém e se a taxa
        aplicada continua dentro do recomendado.
      </p>

      <p>
        <strong>O que o operador informa no app</strong> (Ferramentas → Check
        de calibragem):
      </p>
      <ul>
        <li>
          <strong>Calculadora de adubação</strong> — ícone no topo do check.
          Começa minimizada; um toque abre, outro recolhe. Informe gramas
          por linha, distância (50 a 100 m) e espaçamento; o app calcula
          kg/ha;
        </li>
        <li>
          <strong>Hectares no painel</strong> — no início do plantio e de novo
          a cada abastecida. O app calcula o que foi plantado (agora −
          anterior);
        </li>
        <li>
          <strong>Adubo (kg)</strong>, <strong>semente</strong> e{" "}
          <strong>inoculante (L)</strong> só na abastecida seguinte — a taxa
          de semente aparece em sementes/ha e sementes/m;
        </li>
        <li>
          A <strong>taxa-alvo</strong> já vem da ordem; o operador não precisa
          digitá-la.
        </li>
      </ul>

      <p>
        <strong>Ordem de serviço:</strong> o gestor cria ou edita a ordem na
        plataforma (App de Campo → Check de calibragem ou Ordens de Serviço),
        informa vazão, tanque, taxa-alvo, tolerância e máquina. No app a
        taxa-alvo já vem da ordem. No plantio o operador informa adubo, semente
        e hectares; o app calcula as taxas e compara com o alvo.
      </p>

      <p>
        <strong>Alertas:</strong>
      </p>
      <ul>
        <li>
          o <strong>app avisa o operador</strong> quando a taxa sair do
          esperado;
        </li>
        <li>
          o <strong>gestor é avisado na plataforma</strong> quando a máquina
          estiver fora da dosagem recomendada.
        </li>
      </ul>

      <p>
        <strong>Médias:</strong> o app calcula a média ponderada das últimas
        3 abastecidas e a média total de todas as paradas daquela ordem.
        Esses valores sobem junto com o check para o App de Campo.
      </p>
      <p>
        <strong>Rastreamento:</strong> cada registro fica vinculado à sessão da
        máquina e à ordem de serviço, permitindo consultar produto, taxas e
        quantidades junto com a telemetria e o histórico da operação.
      </p>
    </>
  );
}
